export function addCurrent(company) {
  return {
    type: 'ADD_CURRENT',
    company,
  }
}
